import React, { useCallback, useState } from 'react';
import ReactECharts from './Chart';
import { Button, Box, List, ListItemButton, ListItemText, Typography } from '@mui/material';

const WorkshopUsers = ({ data, height, width, onWorkshopSelect, onClearWorkshop, selectedWorkshop }) => {
  const [hoverData, setHoverData] = useState(null);
  const colorPalette = ['#da291c', '#3cb17e', '#307fe2', '#9063cd', '#2cccd3', '#a2b2c8'];

  const option = {
    color: colorPalette,
    title: {
      //text: 'Users by Workshop',
      left: 'center',
      top: 30,
      textStyle: {
        fontSize: 18,
        fontWeight: 'bold'
      }
    },
    tooltip: {
      show: false
    },
    series: [
      {
        name: 'Workshop Users',
        type: 'pie',
        radius: ['48%', '76%'],
        center: ['60%', '50%'],
        avoidLabelOverlap: false,
        label: {
          show: false
        },
        emphasis: {
          scale: true,
          scaleSize: 10,
          label: {
            show: false
          }
        },
        labelLine: {
          show: false
        },
        data: data
      }
    ]
  };

  const handleChartClick = useCallback((params) => {
    if (params.componentType === 'series') {
      onWorkshopSelect(params.name);
    }
  }, [onWorkshopSelect]);

  const handleMouseOver = useCallback((params) => {
    if (params.componentType === 'series') {
      const total = data.reduce((sum, d) => sum + d.value, 0);
      const percentage = ((params.value / total) * 100).toFixed(2);
      setHoverData({
        name: params.name,
        value: params.value,
        percentage: percentage,
        total: total
      });
    }
  }, [data]);

  const handleMouseOut = useCallback(() => {
    setHoverData(null);
  }, []);

  const onEvents = {
    'click': handleChartClick,
    'mouseover': handleMouseOver,
    'mouseout': handleMouseOut
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      <Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
        <Box sx={{ width: '60%', overflowY: 'auto', borderRight: '1px solid #ccc' }}>
          <List dense>
            {data.map((item, index) => (
              <ListItemButton
                key={item.name}
                onClick={() => onWorkshopSelect(item.name)}
                selected={selectedWorkshop === item.name}
                onMouseEnter={() => handleMouseOver({ componentType: 'series', ...item })}
                onMouseLeave={handleMouseOut}
              >
                <Box 
                  sx={{ 
                    width: 16, 
                    height: 16, 
                    backgroundColor: colorPalette[index % colorPalette.length],
                    marginRight: 1
                  }} 
                />
                <ListItemText primary={item.name} />
              </ListItemButton>
            ))}
          </List>
        </Box>
        <Box sx={{ width: '70%', position: 'relative', display: 'flex', flexDirection: 'column' }}>
          <Button
            onClick={onClearWorkshop}
            variant="outlined"
            size="small"
            disabled={!selectedWorkshop}
            sx={{
              position: 'absolute',
              top: '10px',
              right: '0px',
              zIndex: 1,
              color: selectedWorkshop ? 'black' : 'rgba(0, 0, 0, 0.26)',
              borderColor: selectedWorkshop ? 'black' : 'rgba(0, 0, 0, 0.12)',
              padding: '2px 8px',
              minWidth: '60px',
              fontSize: '0.75rem'
            }}
          >
            Clear
          </Button>
          <Box sx={{ flex: 1, minHeight: 0 }}>
            <ReactECharts
              option={option}
              style={{ height: '100%', width: '85%' }}
              onEvents={onEvents}
            />
          </Box>
        </Box>
      </Box>
      <Box sx={{ 
        height: '120px', 
        display: 'flex', 
        flexDirection: 'column',  
        justifyContent: 'center', 
        alignItems: 'center', 
        padding: '0 16px',
        marginTop:'-30px'
      }}>
        {hoverData ? (
          <>
            <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
              {hoverData.name}
            </Typography>
            <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
              {`${hoverData.value} (${hoverData.percentage}%)`}
            </Typography>
          </>
        ) : (
          <Typography sx={{ fontSize: '0.9rem', color: 'text.secondary' }}>
            
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default WorkshopUsers;